import styles from './WebsiteFavicon.module.scss';

import { Public } from '@mui/icons-material';
import clsx from 'clsx';

export const WebsiteFavicon = (props: {
  website?: string;
  style?: React.CSSProperties;
  className?: string;
}) => {
  const { website, style } = props;
  return website ? (
    <img
      src={`https://www.google.com/s2/favicons?domain=${website}`}
      alt="Favicon"
      className={clsx(styles.favicon, props.className)}
      style={style}
    />
  ) : (
    <Public className={clsx(styles.favicon, props.className)} style={style} />
  );
};
